import OldInspectionsPageFilters from './OldInspectionsPageFilters';

export default OldInspectionsPageFilters;
